var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('progressBar',{attrs:{"getCurrentStep":_vm.getCurrentFreeBetProgress,"getTotalStep":_vm.getTotalFreeBetProgress,"isProgress":true,"isShowCheck":_vm.isFullProgress,"styleCheck":_vm.styleCheck,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }